import React, { useState, useEffect, useReducer } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { get } from "aws-amplify/api";
import dayjs from "dayjs";
import currentUserToken from "CurrentUserToken";
import { APIStatusDialog } from "./APIStatusDialog";
import { I18n } from "aws-amplify/utils";
import SelectAllTransferList from "layouts/profile/components/SelectAllTransferList/SelectAllTransferList";
import { useTemplateController } from "context";
const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    return { audit: action.value, fetched: true };
  }
  return lastState;
};
const reducer2 = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    return { audit: action.value, fetched: true };
  }
  return lastState;
};

function EditPermission({
  open,
  onClose,
  userData,
  onSave,
  profileUser,
  setProfileUser,
}) {
  const [formValues, setFormValues] = useState(userData);
  const [selectedHubs, setSelectedHubs] = useState(null);
  const [selectedCluster, setSelectedCluster] = useState(null);
  const [groupName, setGroupName] = useState(""); // Original group name from API
  const [groupNameSel, setGroupNameSel] = useState(""); // State to store selected group name
  const [hubsTotal, setHubsTotal] = useState([]);
  const [hubs, setHubs] = useState([]);
  const [clusterTotal, setClusterTotal] = useState([]);
  const [cluster, setCluster] = useState([]);
  const [state, dispatch] = useReducer(reducer, { audit: [], fetched: false });
  const [state2, dispatch2] = useReducer(reducer2, {
    audit: [],
    fetched: false,
  });
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  useEffect(() => {
    if (profileUser.includes("Admin")) {
      setSelectedHubs(true);
      setSelectedCluster(false);
    } else if (
      profileUser.includes("Operator") ||
      profileUser.includes("Guest")
    ) {
      setSelectedHubs(false);
      setSelectedCluster(true);
    } else {
      setSelectedHubs(false);
      setSelectedCluster(false);
    }
  }, [profileUser]);

  useEffect(() => {
    const tlmGetUserProfiles = async () => {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/userManagement/group/list",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: { user_id: formValues.user_id },
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();

        // Check if hubs exist in the response and update the state
        const hubsFromAPI = response.find((item) => item.hubs)?.hubs || [];
        setHubsTotal(hubsFromAPI); // Set hubsTotal with the hubs from API
        const clusterFromAPI =
          response.find((item) => item.clusters)?.clusters || [];
        setClusterTotal(clusterFromAPI);
        // Check if profiles exist in the response and update the state
        const profiles = response.find((item) => item.profiles)?.profiles || [];
        dispatch({ type: "DATA_RECEIVED", value: profiles });

        if (profiles.length > 0) {
          setGroupName(profiles[0]); // Set default profile
        }
      } catch (error) {
        console.error("Error fetching user profiles:", error);
      }
    };
    tlmGetUserProfiles();
  }, [formValues.user_id]);

  // Effect to get user profiles and set group name dynamically
  useEffect(() => {
    const tlmGetUserGroups = async () => {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/userManagement/user/groups",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: { user_id: formValues.user_id },
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();
        setHubs(response.hubs.map((hub) => hub.group_name) || []);
        setCluster(
          response.clusters.map((cluster) => cluster.group_name) || []
        );
        setProfileUser(
          response.profiles.map((profile) => profile.group_name) || []
        );
        // Extract profiles from the response and set groupNameSel with the first profile
        const profiles = response.profiles.map((profile) => profile.group_name);

        if (profiles.length > 0) {
          setGroupNameSel(profiles[0]); // Set default selected profile
        }

        dispatch2({ type: "DATA_RECEIVED", value: profiles });
      } catch (error) {
        console.error("Error fetching user groups:", error);
      }
    };
    tlmGetUserGroups();
  }, [formValues.user_id]);

  // Update formValues when userData changes
  useEffect(() => {
    setFormValues(userData);
  }, [userData]);
  const handleClose = () => {
    onClose(); // Trigger the original onClose callback
  };

  // Function to assign the user to the group when saving
  const tlmPostGroupAssignment = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/userManagement/group/assignment",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            group_name: groupNameSel, // Use the selected group name
            user_id: formValues.user_id,
          },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();

      dispatch2({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Error assigning group:", error);
    }
  };
const [controller] = useTemplateController();
  const { darkMode } = controller;
  

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xl" >
      <DialogTitle> {I18n.get("Edit Permission")}</DialogTitle>
      {selectedHubs && (
        <DialogContent>
          <SelectAllTransferList
            onClose={onClose}
            hubsTotal={hubsTotal}
            hubs={hubs}
            profileUser={profileUser}
            user_id={formValues.user_id} // Pass user_id dynamically
          />
        </DialogContent>
      )}
      {selectedCluster && (
        <DialogContent >
          <SelectAllTransferList
            onClose={onClose}
            hubsTotal={clusterTotal}
            hubs={cluster}
            profileUser={profileUser}
            user_id={formValues.user_id} // Pass user_id dynamically
          />
        </DialogContent>
      )}
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
    </Dialog>
  );
}

export default EditPermission;
